/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Step_DateInputs */

const en_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const es_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha`)
};

const de_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum`)
};

const zh_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日期`)
};

const ar_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التاريخ`)
};

const fr_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const vi_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày`)
};

const sw_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarehe`)
};

const th_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันที่`)
};

const bs_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum`)
};

const ja_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付`)
};

const ko_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`날짜`)
};

const pt_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

const it_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

const sv_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum`)
};

const nl_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum`)
};

const da_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dato`)
};

const nb_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dato`)
};

const fi_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivämäärä`)
};

const pl_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

const ru_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата`)
};

const tr_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarih`)
};

const hi_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तारीख`)
};

const id_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal`)
};

const ms_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh`)
};

const cs_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum`)
};

const el_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ημερομηνία`)
};

const he_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תאריך`)
};

const af_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum`)
};

const hu_booking_step_date = /** @type {(inputs: Booking_Step_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dátum`)
};

/**
* | output |
* | --- |
* | "Date" |
*
* @param {Booking_Step_DateInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_step_date = /** @type {((inputs?: Booking_Step_DateInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Step_DateInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_step_date(inputs)
	if (locale === "de") return de_booking_step_date(inputs)
	if (locale === "zh") return zh_booking_step_date(inputs)
	if (locale === "ar") return ar_booking_step_date(inputs)
	if (locale === "fr") return fr_booking_step_date(inputs)
	if (locale === "vi") return vi_booking_step_date(inputs)
	if (locale === "sw") return sw_booking_step_date(inputs)
	if (locale === "th") return th_booking_step_date(inputs)
	if (locale === "bs") return bs_booking_step_date(inputs)
	if (locale === "ja") return ja_booking_step_date(inputs)
	if (locale === "ko") return ko_booking_step_date(inputs)
	if (locale === "pt") return pt_booking_step_date(inputs)
	if (locale === "it") return it_booking_step_date(inputs)
	if (locale === "sv") return sv_booking_step_date(inputs)
	if (locale === "nl") return nl_booking_step_date(inputs)
	if (locale === "da") return da_booking_step_date(inputs)
	if (locale === "nb") return nb_booking_step_date(inputs)
	if (locale === "fi") return fi_booking_step_date(inputs)
	if (locale === "pl") return pl_booking_step_date(inputs)
	if (locale === "ru") return ru_booking_step_date(inputs)
	if (locale === "tr") return tr_booking_step_date(inputs)
	if (locale === "hi") return hi_booking_step_date(inputs)
	if (locale === "id") return id_booking_step_date(inputs)
	if (locale === "ms") return ms_booking_step_date(inputs)
	if (locale === "cs") return cs_booking_step_date(inputs)
	if (locale === "el") return el_booking_step_date(inputs)
	if (locale === "he") return he_booking_step_date(inputs)
	if (locale === "af") return af_booking_step_date(inputs)
	if (locale === "hu") return hu_booking_step_date(inputs)
	return en_booking_step_date(inputs)
});